import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusPage } from '../../Components/StatusPage/StatusPage';

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <StatusPage
      code="404"
      heading="Page not found."
      description="Sorry, we can't find the page you're looking for."
      secondaryLabel="Back to Home"
      onSecondaryClick={() => navigate('/')}
      // footer={<>Looking to book instead? <a href="/outlets" onClick={(e) => { e.preventDefault(); navigate('/outlets'); }}>Browse outlets</a> or <a href="https://www.natureland.com.sg/locations/" target="_blank" rel="noopener noreferrer">contact our front desk</a>.</>}
    />
  );
};

export default NotFound;
